// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PhotoBook Designer Main Styles */
.photobook-designer {
  min-height: 100vh;
}

.designer-container {
  display: flex;
  min-height: calc(100vh - 80px);
  padding: 20px;
  gap: 20px;
  max-width: 100%;
  overflow: hidden;
}

/* Sidebar */
.designer-sidebar {
  width: 264px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-shrink: 0;
  overflow-y: auto;
  max-height: calc(100vh - 100px);
}

.designer-product-info {
  background: #2d3748;
  padding: 25px;
  border-radius: 15px;
  text-align: center;
  color: white;
}

.designer-product-info h2 {
  margin: 0 0 10px 0;
  font-size: 20px;
}

.designer-product-name {
  margin: 5px 0;
  opacity: 0.9;
  font-size: 14px;
}

.designer-product-price {
  margin: 0;
  font-size: 28px;
  font-weight: bold;
}

/* Design stats */
.design-stats {
  display: flex;
  gap: 10px;
}

.stat {
  flex: 1 1;
  background: rgba(255, 255, 255, 0.05);
  padding: 15px;
  border-radius: 10px;
  text-align: center;
}

.stat-value {
  display: block;
  font-size: 24px;
  font-weight: bold;
  color: #667eea;
}

.stat-label {
  display: block;
  font-size: 11px;
  color: #888;
  text-transform: uppercase;
  margin-top: 5px;
}

/* Tab navigation */
.designer-tabs {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tab-btn {
  padding: 15px 20px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #333;
  border-radius: 10px;
  color: #aaa;
  font-size: 14px;
  cursor: pointer;
  text-align: left;
  transition: all 0.3s ease;
}

.tab-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.tab-btn.active {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.3) 0%, rgba(118, 75, 162, 0.3) 100%);
  border-color: #667eea;
  color: #fff;
}

/* Export section */
.export-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 12px;
  border: 1px solid #333;
}

.export-btn {
  padding: 15px 25px;
  background: linear-gradient(135deg, #00b894 0%, #00cec9 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.3s ease;
}

.export-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 5px 20px rgba(0, 184, 148, 0.4);
}

.export-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.export-progress {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  padding: 10px;
  position: relative;
  overflow: hidden;
}

.progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  opacity: 0.3;
  transition: width 0.3s ease;
}

.export-progress span {
  position: relative;
  z-index: 1;
  font-size: 12px;
  color: #fff;
}

.proceed-btn {
  padding: 15px 25px;
  background: #2d3748;
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.proceed-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 5px 20px rgba(102, 126, 234, 0.4);
}

.proceed-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.preview-toggle-btn {
  padding: 12px 25px;
  background: transparent;
  color: #2d3748;
  border: 1.5px solid #2d3748;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.preview-toggle-btn:hover:not(:disabled) {
  background: #2d3748;
  color: #fff;
}

.preview-toggle-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Page info box */
.page-info-box {
  background: rgba(255, 255, 255, 0.05);
  padding: 15px;
  border-radius: 12px;
  border: 1px solid #333;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
}

.page-info-box h4 {
  margin: 0 0 10px 0;
  color: #fff;
  font-size: 14px;
}

.page-info-box p {
  margin: 5px 0;
  color: #aaa;
  font-size: 13px;
  line-height: 1.5;
}

.page-info-box .max-pages {
  color: #667eea;
  font-weight: 600;
}

/* Min photos warning */
.min-photos-warning {
  color: #e62222;
  font-size: 12px;
  text-align: center;
  margin: 5px 0 0 0;
  padding: 12px 15px;
  background: rgba(230, 34, 34, 0.1);
  border: 1px solid rgba(230, 126, 34, 0.3);
  border-radius: 8px;
}

/* Help info */
.help-info {
  background: rgba(102, 126, 234, 0.1);
  padding: 20px;
  border-radius: 12px;
  border: 1px solid rgba(102, 126, 234, 0.3);
}

.help-info h4 {
  color: #403f3f;
  margin: 0 0 15px 0;
  font-size: 14px;
}

.help-info ul {
  margin: 0;
  padding: 0 0 0 20px;
  color: #aaa;
  font-size: 12px;
  line-height: 1.8;
}

.help-info li {
  margin-bottom: 5px;
}

/* ── Section headings (Kopertina / Faqet) ── */
.designer-section-heading {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 14px;
  font-family: 'Montserrat', Arial, sans-serif;
  padding-bottom: 10px;
  border-bottom: 2px solid #e2e8f0;
}

.cover-surcharge-inline {
  background: linear-gradient(135deg, #ef6d49, #ff9b6a);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 999px;
  font-family: 'Montserrat', Arial, sans-serif;
}

.designer-cover-section {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);
  margin-bottom: 24px;
}

.designer-pages-section {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);
}

/* Sidebar cover controls wrapper */
.sidebar-cover-controls {
  width: 100%;
}

.sidebar-cover-controls .cover-controls-panel {
  width: 100%;
  max-height: none;
  padding-right: 0;
}

/* Cover surcharge note in product info */
.cover-surcharge-note {
  font-size: 12px;
  color: #ef6d49;
  font-weight: 700;
  margin: 2px 0 0;
  font-family: 'Montserrat', Arial, sans-serif;
}

/* Remove old surcharge badge */
.cover-surcharge-badge {
  background: linear-gradient(135deg, #ef6d49, #ff9b6a);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  padding: 8px 14px;
  border-radius: 10px;
  text-align: center;
  font-family: 'Montserrat', Arial, sans-serif;
}

/* Main design area */
.designer-main {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  max-width: 100%;
}

/* Export modal */
.export-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.export-modal {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  padding: 40px;
  border-radius: 20px;
  text-align: center;
  max-width: 400px;
  width: 90%;
  animation: slideUp 0.3s ease;
  border: 1px solid #333;
}

@keyframes slideUp {
  from { 
    opacity: 0;
    transform: translateY(30px);
  }
  to { 
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-icon {
  font-size: 60px;
  margin-bottom: 20px;
}

.export-modal h3 {
  color: #fff;
  margin: 0 0 10px 0;
  font-size: 24px;
}

.export-modal > p {
  color: #888;
  margin: 0 0 25px 0;
}

.modal-details {
  background: rgba(0, 0, 0, 0.3);
  padding: 15px;
  border-radius: 10px;
  margin-bottom: 25px;
  text-align: left;
}

.modal-details p {
  color: #aaa;
  margin: 8px 0;
  font-size: 13px;
}

.export-modal button {
  padding: 12px 40px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.export-modal button:hover {
  transform: scale(1.05);
}

/* ── Mobile drawer (hidden on desktop) ── */
.drawer-toggle-tab {
  display: none;
}

.mobile-drawer {
  display: none;
}

/* ── Tablet (≤1100px) ── */
@media (max-width: 1100px) {
  .designer-container {
    flex-direction: column;
    padding: 10px;
    gap: 10px;
  }

  /* Drawer toggle — fixed pill just below the site header (which is
     \`position: sticky\` with \`z-index: 1000\`, see Header.css — sitting any
     higher would tuck this behind it), always opens the drawer (closing
     happens via the drawer's own × button, since the drawer covers the
     whole screen when open). */
  .drawer-toggle-tab {
    display: flex;
    align-items: center;
    gap: 6px;
    position: fixed;
    top: 100px;
    right: 10px;
    padding: 10px 14px;
    background: #2d3748;
    color: #fff;
    border: none;
    border-radius: 10px;
    z-index: 900;
    box-shadow: 0 2px 10px rgba(0,0,0,0.2);
  }

  .drawer-toggle-arrow {
    font-size: 16px;
    line-height: 1;
  }

  .drawer-toggle-label {
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
  }

  /* Full-screen drawer — product info, stats, photo library/cover controls.
     z-index must clear the site header's own \`position: sticky; z-index:
     1000\` (Header.css) or the header would stay pinned on top of the
     drawer's own header instead of being covered by it. Simple show/hide
     (no transform, so it never risks becoming a containing block for any
     fixed-position descendant, e.g. .export-section below, which relies
     on position:fixed to stay pinned to the viewport). */
  .mobile-drawer {
    display: none;
    position: fixed;
    inset: 0;
    z-index: 1100;
    background: #fff;
    flex-direction: column;
  }

  .mobile-drawer.open {
    display: flex;
  }

  .mobile-drawer-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 16px 16px 14px;
    background: #1a202c;
    color: #fff;
    flex-shrink: 0;
  }

  .mobile-drawer-header h3 {
    margin: 0 0 4px;
    font-size: 16px;
  }

  .mobile-drawer-price {
    font-size: 20px;
    font-weight: 700;
  }

  .mobile-drawer-close {
    width: 34px;
    height: 34px;
    flex-shrink: 0;
    background: rgba(255,255,255,0.1);
    color: #fff;
    border: none;
    border-radius: 50%;
    font-size: 20px;
    line-height: 1;
    cursor: pointer;
  }

  .mobile-drawer-body {
    flex: 1 1;
    overflow-y: auto;
    padding: 16px;
    padding-bottom: 32px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .mobile-drawer-body .page-info-box,
  .mobile-drawer-body .design-stats {
    width: 100%;
  }

  .mobile-drawer-body .cover-controls-panel {
    width: 100%;
    max-height: none;
    flex-direction: column;
    gap: 10px;
    padding-right: 0;
  }

  .mobile-drawer-body .cover-section {
    min-width: 0;
  }

  .drawer-pages-slot {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  /* Desktop sidebar — on mobile only its fixed .export-section child stays
     visible (pinned to the viewport bottom); everything else moved into
     .mobile-drawer above. */
  .designer-sidebar {
    display: block;
    width: auto;
    padding: 0;
    background: none;
    border: none;
  }

  .designer-sidebar > *:not(.export-section) {
    display: none;
  }

  /* Proceed button: fixed bar at bottom */
  .export-section {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 200;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    padding: 10px 16px;
    padding-bottom: max(10px, env(safe-area-inset-bottom));
    background: #fff;
    border: none;
    border-top: 1px solid #e2e8f0;
    border-radius: 0;
    box-shadow: 0 -4px 20px rgba(0,0,0,0.12);
  }

  .proceed-btn {
    flex: 1 1;
    padding: 14px 20px;
    font-size: 15px;
    border-radius: 10px;
  }

  .preview-toggle-btn {
    flex: 0 0 auto;
    padding: 14px 16px;
    font-size: 14px;
    border-radius: 10px;
  }

  .min-photos-warning {
    flex: 1 1;
    font-size: 11px;
    margin: 0;
    padding: 8px 10px;
  }

  .designer-main {
    padding-bottom: 80px;
  }
}

/* ── Mobile (≤600px) ── */
@media (max-width: 600px) {
  .designer-container {
    padding: 6px;
    gap: 6px;
  }

  .designer-sidebar {
    gap: 6px;
  }

  .designer-product-info {
    min-width: 130px;
    padding: 10px 12px;
  }

  .designer-product-info h2    { font-size: 13px; }
  .designer-product-price      { font-size: 18px; }
  .cover-surcharge-note        { font-size: 11px; }

  .designer-sidebar .page-info-box { display: none; }

  .stat-value { font-size: 18px; }
  .stat-label { font-size: 10px; }

  .export-section {
    padding: 8px 12px;
    padding-bottom: max(8px, env(safe-area-inset-bottom));
    gap: 8px;
  }

  .proceed-btn {
    padding: 12px 16px;
    font-size: 14px;
  }

  .preview-toggle-btn {
    padding: 12px 14px;
    font-size: 13px;
  }

  .designer-main {
    padding-bottom: 70px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PhotoBook/PhotoBookDesigner.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,8FAA8F;EAC9F,qBAAqB;EACrB,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,4DAA4D;EAC5D,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,4CAA4C;EAC5C,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,6CAA6C;AAC/C;;AAEA,mCAAmC;AACnC;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,4CAA4C;AAC9C;;AAEA,+BAA+B;AAC/B;EACE,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA,qBAAqB;AACrB;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,aAAa;IACb,SAAS;EACX;;EAEA;;;;+BAI6B;EAC7B;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,sCAAsC;EACxC;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;;;;;yDAMuD;EACvD;IACE,aAAa;IACb,eAAe;IACf,QAAQ;IACR,aAAa;IACb,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iCAAiC;IACjC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;;4BAE0B;EAC1B;IACE,cAAc;IACd,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA,wCAAwC;EACxC;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,sDAAsD;IACtD,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,wCAAwC;EAC1C;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,eAAe;IACf,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,+BAA+B,eAAe,EAAE;EAChD,+BAA+B,eAAe,EAAE;EAChD,+BAA+B,eAAe,EAAE;;EAEhD,mCAAmC,aAAa,EAAE;;EAElD,cAAc,eAAe,EAAE;EAC/B,cAAc,eAAe,EAAE;;EAE/B;IACE,iBAAiB;IACjB,qDAAqD;IACrD,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":["/* PhotoBook Designer Main Styles */\n.photobook-designer {\n  min-height: 100vh;\n}\n\n.designer-container {\n  display: flex;\n  min-height: calc(100vh - 80px);\n  padding: 20px;\n  gap: 20px;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n/* Sidebar */\n.designer-sidebar {\n  width: 264px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  flex-shrink: 0;\n  overflow-y: auto;\n  max-height: calc(100vh - 100px);\n}\n\n.designer-product-info {\n  background: #2d3748;\n  padding: 25px;\n  border-radius: 15px;\n  text-align: center;\n  color: white;\n}\n\n.designer-product-info h2 {\n  margin: 0 0 10px 0;\n  font-size: 20px;\n}\n\n.designer-product-name {\n  margin: 5px 0;\n  opacity: 0.9;\n  font-size: 14px;\n}\n\n.designer-product-price {\n  margin: 0;\n  font-size: 28px;\n  font-weight: bold;\n}\n\n/* Design stats */\n.design-stats {\n  display: flex;\n  gap: 10px;\n}\n\n.stat {\n  flex: 1;\n  background: rgba(255, 255, 255, 0.05);\n  padding: 15px;\n  border-radius: 10px;\n  text-align: center;\n}\n\n.stat-value {\n  display: block;\n  font-size: 24px;\n  font-weight: bold;\n  color: #667eea;\n}\n\n.stat-label {\n  display: block;\n  font-size: 11px;\n  color: #888;\n  text-transform: uppercase;\n  margin-top: 5px;\n}\n\n/* Tab navigation */\n.designer-tabs {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.tab-btn {\n  padding: 15px 20px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid #333;\n  border-radius: 10px;\n  color: #aaa;\n  font-size: 14px;\n  cursor: pointer;\n  text-align: left;\n  transition: all 0.3s ease;\n}\n\n.tab-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n.tab-btn.active {\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.3) 0%, rgba(118, 75, 162, 0.3) 100%);\n  border-color: #667eea;\n  color: #fff;\n}\n\n/* Export section */\n.export-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 20px;\n  background: rgba(255, 255, 255, 0.03);\n  border-radius: 12px;\n  border: 1px solid #333;\n}\n\n.export-btn {\n  padding: 15px 25px;\n  background: linear-gradient(135deg, #00b894 0%, #00cec9 100%);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  transition: all 0.3s ease;\n}\n\n.export-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 20px rgba(0, 184, 148, 0.4);\n}\n\n.export-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.spinner {\n  width: 18px;\n  height: 18px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.export-progress {\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 8px;\n  padding: 10px;\n  position: relative;\n  overflow: hidden;\n}\n\n.progress-bar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);\n  opacity: 0.3;\n  transition: width 0.3s ease;\n}\n\n.export-progress span {\n  position: relative;\n  z-index: 1;\n  font-size: 12px;\n  color: #fff;\n}\n\n.proceed-btn {\n  padding: 15px 25px;\n  background: #2d3748;\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.proceed-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 20px rgba(102, 126, 234, 0.4);\n}\n\n.proceed-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.preview-toggle-btn {\n  padding: 12px 25px;\n  background: transparent;\n  color: #2d3748;\n  border: 1.5px solid #2d3748;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.preview-toggle-btn:hover:not(:disabled) {\n  background: #2d3748;\n  color: #fff;\n}\n\n.preview-toggle-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Page info box */\n.page-info-box {\n  background: rgba(255, 255, 255, 0.05);\n  padding: 15px;\n  border-radius: 12px;\n  border: 1px solid #333;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  width: 100%;\n}\n\n.page-info-box h4 {\n  margin: 0 0 10px 0;\n  color: #fff;\n  font-size: 14px;\n}\n\n.page-info-box p {\n  margin: 5px 0;\n  color: #aaa;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.page-info-box .max-pages {\n  color: #667eea;\n  font-weight: 600;\n}\n\n/* Min photos warning */\n.min-photos-warning {\n  color: #e62222;\n  font-size: 12px;\n  text-align: center;\n  margin: 5px 0 0 0;\n  padding: 12px 15px;\n  background: rgba(230, 34, 34, 0.1);\n  border: 1px solid rgba(230, 126, 34, 0.3);\n  border-radius: 8px;\n}\n\n/* Help info */\n.help-info {\n  background: rgba(102, 126, 234, 0.1);\n  padding: 20px;\n  border-radius: 12px;\n  border: 1px solid rgba(102, 126, 234, 0.3);\n}\n\n.help-info h4 {\n  color: #403f3f;\n  margin: 0 0 15px 0;\n  font-size: 14px;\n}\n\n.help-info ul {\n  margin: 0;\n  padding: 0 0 0 20px;\n  color: #aaa;\n  font-size: 12px;\n  line-height: 1.8;\n}\n\n.help-info li {\n  margin-bottom: 5px;\n}\n\n/* ── Section headings (Kopertina / Faqet) ── */\n.designer-section-heading {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 16px;\n  font-weight: 700;\n  color: #2d3748;\n  margin-bottom: 14px;\n  font-family: 'Montserrat', Arial, sans-serif;\n  padding-bottom: 10px;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.cover-surcharge-inline {\n  background: linear-gradient(135deg, #ef6d49, #ff9b6a);\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 3px 10px;\n  border-radius: 999px;\n  font-family: 'Montserrat', Arial, sans-serif;\n}\n\n.designer-cover-section {\n  background: #fff;\n  border-radius: 16px;\n  padding: 20px;\n  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);\n  margin-bottom: 24px;\n}\n\n.designer-pages-section {\n  background: #fff;\n  border-radius: 16px;\n  padding: 20px;\n  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);\n}\n\n/* Sidebar cover controls wrapper */\n.sidebar-cover-controls {\n  width: 100%;\n}\n\n.sidebar-cover-controls .cover-controls-panel {\n  width: 100%;\n  max-height: none;\n  padding-right: 0;\n}\n\n/* Cover surcharge note in product info */\n.cover-surcharge-note {\n  font-size: 12px;\n  color: #ef6d49;\n  font-weight: 700;\n  margin: 2px 0 0;\n  font-family: 'Montserrat', Arial, sans-serif;\n}\n\n/* Remove old surcharge badge */\n.cover-surcharge-badge {\n  background: linear-gradient(135deg, #ef6d49, #ff9b6a);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 8px 14px;\n  border-radius: 10px;\n  text-align: center;\n  font-family: 'Montserrat', Arial, sans-serif;\n}\n\n/* Main design area */\n.designer-main {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  max-width: 100%;\n}\n\n/* Export modal */\n.export-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.export-modal {\n  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);\n  padding: 40px;\n  border-radius: 20px;\n  text-align: center;\n  max-width: 400px;\n  width: 90%;\n  animation: slideUp 0.3s ease;\n  border: 1px solid #333;\n}\n\n@keyframes slideUp {\n  from { \n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to { \n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.modal-icon {\n  font-size: 60px;\n  margin-bottom: 20px;\n}\n\n.export-modal h3 {\n  color: #fff;\n  margin: 0 0 10px 0;\n  font-size: 24px;\n}\n\n.export-modal > p {\n  color: #888;\n  margin: 0 0 25px 0;\n}\n\n.modal-details {\n  background: rgba(0, 0, 0, 0.3);\n  padding: 15px;\n  border-radius: 10px;\n  margin-bottom: 25px;\n  text-align: left;\n}\n\n.modal-details p {\n  color: #aaa;\n  margin: 8px 0;\n  font-size: 13px;\n}\n\n.export-modal button {\n  padding: 12px 40px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.export-modal button:hover {\n  transform: scale(1.05);\n}\n\n/* ── Mobile drawer (hidden on desktop) ── */\n.drawer-toggle-tab {\n  display: none;\n}\n\n.mobile-drawer {\n  display: none;\n}\n\n/* ── Tablet (≤1100px) ── */\n@media (max-width: 1100px) {\n  .designer-container {\n    flex-direction: column;\n    padding: 10px;\n    gap: 10px;\n  }\n\n  /* Drawer toggle — fixed pill just below the site header (which is\n     `position: sticky` with `z-index: 1000`, see Header.css — sitting any\n     higher would tuck this behind it), always opens the drawer (closing\n     happens via the drawer's own × button, since the drawer covers the\n     whole screen when open). */\n  .drawer-toggle-tab {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    position: fixed;\n    top: 100px;\n    right: 10px;\n    padding: 10px 14px;\n    background: #2d3748;\n    color: #fff;\n    border: none;\n    border-radius: 10px;\n    z-index: 900;\n    box-shadow: 0 2px 10px rgba(0,0,0,0.2);\n  }\n\n  .drawer-toggle-arrow {\n    font-size: 16px;\n    line-height: 1;\n  }\n\n  .drawer-toggle-label {\n    font-size: 13px;\n    font-weight: 600;\n    white-space: nowrap;\n  }\n\n  /* Full-screen drawer — product info, stats, photo library/cover controls.\n     z-index must clear the site header's own `position: sticky; z-index:\n     1000` (Header.css) or the header would stay pinned on top of the\n     drawer's own header instead of being covered by it. Simple show/hide\n     (no transform, so it never risks becoming a containing block for any\n     fixed-position descendant, e.g. .export-section below, which relies\n     on position:fixed to stay pinned to the viewport). */\n  .mobile-drawer {\n    display: none;\n    position: fixed;\n    inset: 0;\n    z-index: 1100;\n    background: #fff;\n    flex-direction: column;\n  }\n\n  .mobile-drawer.open {\n    display: flex;\n  }\n\n  .mobile-drawer-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 16px 16px 14px;\n    background: #1a202c;\n    color: #fff;\n    flex-shrink: 0;\n  }\n\n  .mobile-drawer-header h3 {\n    margin: 0 0 4px;\n    font-size: 16px;\n  }\n\n  .mobile-drawer-price {\n    font-size: 20px;\n    font-weight: 700;\n  }\n\n  .mobile-drawer-close {\n    width: 34px;\n    height: 34px;\n    flex-shrink: 0;\n    background: rgba(255,255,255,0.1);\n    color: #fff;\n    border: none;\n    border-radius: 50%;\n    font-size: 20px;\n    line-height: 1;\n    cursor: pointer;\n  }\n\n  .mobile-drawer-body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 16px;\n    padding-bottom: 32px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .mobile-drawer-body .page-info-box,\n  .mobile-drawer-body .design-stats {\n    width: 100%;\n  }\n\n  .mobile-drawer-body .cover-controls-panel {\n    width: 100%;\n    max-height: none;\n    flex-direction: column;\n    gap: 10px;\n    padding-right: 0;\n  }\n\n  .mobile-drawer-body .cover-section {\n    min-width: 0;\n  }\n\n  .drawer-pages-slot {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  /* Desktop sidebar — on mobile only its fixed .export-section child stays\n     visible (pinned to the viewport bottom); everything else moved into\n     .mobile-drawer above. */\n  .designer-sidebar {\n    display: block;\n    width: auto;\n    padding: 0;\n    background: none;\n    border: none;\n  }\n\n  .designer-sidebar > *:not(.export-section) {\n    display: none;\n  }\n\n  /* Proceed button: fixed bar at bottom */\n  .export-section {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 200;\n    flex-direction: row;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 16px;\n    padding-bottom: max(10px, env(safe-area-inset-bottom));\n    background: #fff;\n    border: none;\n    border-top: 1px solid #e2e8f0;\n    border-radius: 0;\n    box-shadow: 0 -4px 20px rgba(0,0,0,0.12);\n  }\n\n  .proceed-btn {\n    flex: 1;\n    padding: 14px 20px;\n    font-size: 15px;\n    border-radius: 10px;\n  }\n\n  .preview-toggle-btn {\n    flex: 0 0 auto;\n    padding: 14px 16px;\n    font-size: 14px;\n    border-radius: 10px;\n  }\n\n  .min-photos-warning {\n    flex: 1;\n    font-size: 11px;\n    margin: 0;\n    padding: 8px 10px;\n  }\n\n  .designer-main {\n    padding-bottom: 80px;\n  }\n}\n\n/* ── Mobile (≤600px) ── */\n@media (max-width: 600px) {\n  .designer-container {\n    padding: 6px;\n    gap: 6px;\n  }\n\n  .designer-sidebar {\n    gap: 6px;\n  }\n\n  .designer-product-info {\n    min-width: 130px;\n    padding: 10px 12px;\n  }\n\n  .designer-product-info h2    { font-size: 13px; }\n  .designer-product-price      { font-size: 18px; }\n  .cover-surcharge-note        { font-size: 11px; }\n\n  .designer-sidebar .page-info-box { display: none; }\n\n  .stat-value { font-size: 18px; }\n  .stat-label { font-size: 10px; }\n\n  .export-section {\n    padding: 8px 12px;\n    padding-bottom: max(8px, env(safe-area-inset-bottom));\n    gap: 8px;\n  }\n\n  .proceed-btn {\n    padding: 12px 16px;\n    font-size: 14px;\n  }\n\n  .preview-toggle-btn {\n    padding: 12px 14px;\n    font-size: 13px;\n  }\n\n  .designer-main {\n    padding-bottom: 70px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
